import React, { useCallback } from 'react'

import { DetailItemCardVariant } from '../common/types'

import { LEFlightItem } from 'tripPlanner/types/tripItem'
import { buildStandaloneFlightSearchURL } from 'tripPlanner/utils/bookmark/restoreCart'
import TextButton from 'components/Luxkit/Button/TextButton'
import useRestoreCart, { BOOK_NOW_BUTTON_TEXT } from 'tripPlanner/hooks/useRestoreCart'
import { tripSavedItemBookNowClicked } from 'analytics/eventDefinitions'
import { fireInteractionEvent } from 'api/googleTagManager'
import Group from 'components/utils/Group'

interface Props {
  item: LEFlightItem
  variant: DetailItemCardVariant
}

function FlightCTAContent({ item, variant }: Props) {
  const flightSearchURL = buildStandaloneFlightSearchURL(
    item.savedItemData,
  )
  const { canRestoreCart, onClick } = useRestoreCart(item, flightSearchURL)

  const source =
    variant === 'drawer' ? 'trip_drawer_all_saved_items' : 'trip_summary'
  const onClickRestoreCartButton = useCallback<
    React.MouseEventHandler<HTMLButtonElement>
  >(
    (e) => {
      if (e.currentTarget.textContent === BOOK_NOW_BUTTON_TEXT) {
        fireInteractionEvent(tripSavedItemBookNowClicked(source))
      }
      onClick(e)
    },
    [source, onClick],
  )

  const showBookNowButton = canRestoreCart && variant === 'drawer'

  return (
    <Group
      direction="horizontal"
      verticalAlign="center"
      horizontalAlign="stretch"
      tabletHorizontalAlign="end"
      gap={12}
    >
      <TextButton
        kind={variant === 'drawer' && !showBookNowButton ? 'primary' : 'secondary'}
        to={flightSearchURL}
        target="_blank"
      >
        Search flights
      </TextButton>
      {showBookNowButton && (
        <TextButton
          kind="primary"
          onClick={onClickRestoreCartButton}
        >
          {BOOK_NOW_BUTTON_TEXT}
        </TextButton>
      )}
    </Group>
  )
}

export default FlightCTAContent
